import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './company_index.route';

import CompanyService from '../../../components/api/company/company.service';

export class CompanyIndexController {
  /*@ngInject*/
  constructor(CompanyService, $stateParams) {
    this.stateName = $stateParams.stateName;
    this.linkTo = `oem_main.${this.stateName}`;

    this.companyList = [];
    this.CompanyService = CompanyService;
  }

  $onInit() {
    this.CompanyService.index(response => {
      this.companyList = response;
    });
  }
}

export default angular.module('leptonApp.companyIndex', [uiRouter, CompanyService])
  .config(routing)
  .component('companyIndex', {
    template: require('./company_index.html'),
    controller: CompanyIndexController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/company/index/company_index.component.js